'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isAvailableOn;

var _iteratorFactory = require('./iteratorFactory');

function isAvailableOn(obj, cal) {
    var iterator = (0, _iteratorFactory.iter)(obj)(cal);

    if (!iterator.hasNext()) return false;

    return iterator.next().status === 'available';
}